import { render } from "./AlertModal.vue?vue&type=template&id=63116083&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=63116083&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63116083"],['__file',"src/components/GenericComponents/AlertModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63116083"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63116083', __exports__)) {
    api.reload('63116083', __exports__)
  }
  
  module.hot.accept("./AlertModal.vue?vue&type=template&id=63116083&scoped=true", () => {
    api.rerender('63116083', render)
  })

}


export default __exports__